module.exports = __webpack_public_path__ + "assets/2e88dc853b885e59a178790c85a9a5fd.png";